module.exports = __webpack_public_path__ + "img/trasporto-hov.8c684ef7.png";